// AUTO-STUB — à remplacer par l'implémentation réelle
import React from 'react';
export function EmptyState(_props: any): React.ReactElement | null {
  return null;
}
export default EmptyState;
